import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-conference-solid text-light py-4">
            <div className="container">
                <div className="row align-items-center">
                    {/* Left Column - Copyright and Contact */}
                    <div className="col-md-8">
                        <p className="mb-1">&copy; {new Date().getFullYear()} All rights reserved. Multinational Finance Society.</p>
                        <p className="mb-0">Contact us: mfs@mfsociety.org</p>
                    </div>
                    
                    {/* Right Column - Social Media Icons */}
                    <div className="col-md-4 text-md-end text-center mt-3 mt-md-0">
                        <p className="mb-2">Follow us:</p>
                        <div className="social-links">
                            <a 
                                href="https://www.facebook.com/MFSociety1995" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-light me-3"
                                style={{ fontSize: '1.5rem', transition: 'color 0.3s ease' }}
                                onMouseEnter={(e) => e.target.style.color = '#1877f2'}
                                onMouseLeave={(e) => e.target.style.color = 'white'}
                            >
                                <i className="bi bi-facebook"></i>
                            </a>
                            <a 
                                href="https://x.com/MFSociety1995" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-light me-3"
                                style={{ fontSize: '1.5rem', transition: 'color 0.3s ease' }}
                                onMouseEnter={(e) => e.target.style.color = '#1da1f2'}
                                onMouseLeave={(e) => e.target.style.color = 'white'}
                            >
                                <i className="bi bi-twitter-x"></i>
                            </a>
                            <a 
                                href="https://www.instagram.com/mfsociety1995/" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-light me-3"
                                style={{ fontSize: '1.5rem', transition: 'color 0.3s ease' }}
                                onMouseEnter={(e) => e.target.style.color = '#e4405f'}
                                onMouseLeave={(e) => e.target.style.color = 'white'}
                            >
                                <i className="bi bi-instagram"></i>
                            </a>
                            <a 
                                href="https://www.youtube.com/channel/UC_1zJe9KyXN-vRBsCLnp9IA" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-light"
                                style={{ fontSize: '1.5rem', transition: 'color 0.3s ease' }}
                                onMouseEnter={(e) => e.target.style.color = '#ff0000'}
                                onMouseLeave={(e) => e.target.style.color = 'white'}
                            >
                                <i className="bi bi-youtube"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;